import { useSyncExternalStore } from 'react';
import {
  getPreference,
  resolveTheme,
  setPreference,
  subscribe,
  type ThemePreference,
  type ResolvedTheme,
} from './theme';

/**
 * React binding for the theme controller. Re-renders whenever the preference
 * or the resolved theme changes (including live OS changes while on 'system').
 */
export function useTheme(): {
  preference: ThemePreference;
  resolved: ResolvedTheme;
  setPreference: (p: ThemePreference) => void;
} {
  const preference = useSyncExternalStore(subscribe, getPreference, () => 'system' as ThemePreference);
  const resolved = useSyncExternalStore(subscribe, () => resolveTheme(), () => 'light' as ResolvedTheme);
  return { preference, resolved, setPreference };
}
